import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: [
		'LandingLanguageButton',
		'LandingHead',
		'LandingTitle',
		'LandingLottieAnimation',
		'LandingProgressLoader',
		'LandingFooter',
	],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: '28-Day Boudoir Pilates Plan based on your age',
			size: 'small',
			customStyles: {
				marginLeft: '2rem',
				marginRight: '2rem',
			},
		}),

		LandingLottieAnimation: (): LandingComponentsConfig['LandingLottieAnimation'] => ({
			animationData: require('@/data/lottie-animations/femaleLoader.json'),
			loop: false,
			customStyles: {
				height: '50vh',
				marginTop: 'var(--size-18)',
				marginBottom: 'var(--size-18)',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
